export default __webpack_public_path__ + "static/media/twitterLogo.def7d13d.png";